import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import Hero from './Hero/Hero';
import ResponsibilityBody from './ResponsibilityBody/ResponsibilityBody';
import './Responsibility.css';
import ComponentData from './data.json';

const Responsibility = ({ isDesktop, buttons }) => {
    return (
        <div className="responsibility-view">
            <Helmet>
                <title>Sustainability | HPP</title>
                <meta
                    name="description"
                    property="og:description"
                    content="Responsible operations are a cornerstone of our promise to deliver for all our stakeholders.
                             We have immediate priorities and a long term vision to protect the environment and help tenants,
                             employees and local communities prosper."
                />
            </Helmet>

            <Hero isDesktop={isDesktop} buttons={buttons}/>
            <div className='responsibility-view-body'>
                {ComponentData.sections.map((blockData, index) => {
                    return (
                        <ResponsibilityBody key={index} blockData={blockData} isDesktop={isDesktop} />
                    );
                })}
            </div>
        </div>
    );
};

Responsibility.propTypes = {
    isDesktop: PropTypes.bool,
    buttons: PropTypes.object,
};

export default connect(
    ({ screen, content }) => ({
        isDesktop: screen.isDesktop,
        buttons: content.responsibility,
    }),
    null,
)(Responsibility);
